<template>
    <div id="fixedNavbar" align="center" v-if="$vuetify.breakpoint.mdAndUp">
        <div style="background-color: #920825;" class="py-5">
            <v-row class="ml-10"  align="center">
                <v-icon color="white" class="mx-2">mdi-phone</v-icon>
                <a href="tel:+3614560596" class="white--text mr-7">+36-1-456-0596</a>
                <v-icon color="white" class="mx-2">mdi-email</v-icon>
                <a href="mailto:support@bns.hu" class="white--text mr-7">office@bns.hu</a>
                <v-icon color="white" class="mx-2">mdi-map-marker-radius</v-icon>
                <a href="https://www.google.com/maps/place/BNS+M%C3%A9rn%C3%B6kiroda+Kft./@47.4793991,19.0733306,16.04z/data=!4m9!1m2!2m1!1sbns!3m5!1s0x4741dcf93ab92cdd:0xa8aa20cdde57975!8m2!3d47.4808755!4d19.072694!15sCgNibnMiA4gBAZIBE2luZHVzdHJpYWxfZW5naW5lZXI" target="_blank" class="white--text mr-7">1094 Budapest, Ferenc tér 2.</a>
            </v-row>
        </div>
        <v-row id="button_bar" align="center" no-gutters>
            <a @click="goToPath('/')">
                <img src="@/assets/bns.svg" class="ml-10 mr-3" width="100rem"/>
            </a>
            <v-btn plain tile color="black" class="nav_btn mx-1" height="5rem" width="6rem" to="/">Főoldal</v-btn>
            <v-btn plain tile color="black" class="nav_btn mx-1" height="5rem" to="/rolunk">Rólunk</v-btn>
            <v-btn plain tile color="black" class="nav_btn mx-1" height="5rem" to="/iso">Iso 9001</v-btn>
            <v-menu offset-y open-on-hover rounded="0">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    plain
                    tile
                    color="black"
                    class="nav_btn mx-1"
                    height="5rem"
                    v-bind="attrs"
                    v-on="on"
                    >Termékek<v-icon>mdi-menu-down</v-icon></v-btn>
                </template>
                <v-list>
                    <v-list-item>
                        <v-btn text plain to="/belteri">Beltéri gyártmányok</v-btn>
                    </v-list-item>
                    <v-list-item>
                        <v-btn text plain to="/kulteri">Kültéri gyártmányok</v-btn>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn plain tile color="black" class="nav_btn mx-1" height="5rem" to="/media">Média</v-btn>
            <v-btn plain tile color="black" class="nav_btn mx-1" height="5rem" to="/kapcsolat">Kapcsolat</v-btn>
        </v-row>
  </div>

  <div id="m-navbar" v-else>
      <v-row align="center" no-gutters>
            <a @click="goToPath('/')">
                <img src="@/assets/bns.svg" class="ml-5 my-3" width="80rem"/>
            </a>
            <v-spacer></v-spacer>
            <v-icon v-if="drawer" class="mr-5" @click="drawer = !drawer">mdi-close</v-icon>
            <v-icon v-else class="mr-5" @click="drawer = !drawer">mdi-menu</v-icon>
        </v-row>

        <v-navigation-drawer 
            v-model="drawer"
            left
            fixed
            temporary
            >
            <v-app-bar height="73rem" align="center" style="background-color:#920825">
                <img src="@/assets/bns-white.png" class="ml-0 my-3" width="80rem"/>
            </v-app-bar>


            <v-list
            v-if="drawer"
            nav
            dense
            >
            <v-list-item-group
                v-model="group"
                color="#920825"
            >
                <v-list-item to="/">
                    <v-list-item-title>Főoldal</v-list-item-title>
                </v-list-item>
                <v-list-item to="/rolunk">
                    <v-list-item-title>Rólunk</v-list-item-title>
                </v-list-item>
                <v-list-item to="/iso">
                    <v-list-item-title>Iso 9001</v-list-item-title>
                </v-list-item>  
                <v-list-group color="#920825">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Termékek</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item to="/belteri" class="ml-3">
                        <v-list-item-title>Beltéri gyártmányok</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/kulteri" class="ml-3">
                        <v-list-item-title>Kültéri gyártmányok</v-list-item-title>
                    </v-list-item>
                </v-list-group>
                <v-list-item to="/media">
                    <v-list-item-title>Média</v-list-item-title>
                </v-list-item>
                <v-list-item to="/kapcsolat">
                    <v-list-item-title>Kapcsolat</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
            </v-list>
            </v-navigation-drawer>
  </div>

  
</template>

<script>
export default {
    name:'Navbar',
    data(){
        return{
            drawer:false,
            nav:[
                {title: 'Főoldal', path: '/'},
                {title: 'Rólunk', path: '/rolunk'},
                {title: 'Iso 9001', path: '/iso'},
                {title: 'Termékek', path: '/termekek'},
                {title: 'Média', path: '/media'},
                {title: 'Kapcsolat', path: '/kapcsolat'},
            ]
        } 
    },
    methods:{
        goToPath(path){
            this.$router.push(path)
        }
    }
}
</script>

<style scoped>
    #fixedNavbar{
        width: 100%;
        position:fixed;
        z-index: 200;
        left: 0;
        top: 0;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
    #m-navbar{
        width: 100%;
        background-color: rgba(255, 255, 255, 1);;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        position:fixed;
        z-index: 200;
    }
    #button_bar{
        background-color: white;
        
    }
    a{
        text-decoration: none;
    }
    a:hover{
        text-decoration: underline;
        text-decoration-color: white;
    }
</style>